var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31579 6.31579C5.44737 6.31579 4.70395 6.00658 4.08553 5.38816C3.46711 4.76974 3.15789 4.02632 3.15789 3.15789C3.15789 2.28947 3.46711 1.54605 4.08553 0.927632C4.70395 0.309211 5.44737 0 6.31579 0C7.18421 0 7.92763 0.309211 8.54605 0.927632C9.16447 1.54605 9.47368 2.28947 9.47368 3.15789C9.47368 4.02632 9.16447 4.76974 8.54605 5.38816C7.92763 6.00658 7.18421 6.31579 6.31579 6.31579ZM0 12.6316V10.4211C0 9.97369 0.115263 9.56237 0.34579 9.18711C0.576316 8.81184 0.882105 8.52579 1.26316 8.32895C2.07895 7.92105 2.90789 7.615 3.75 7.41079C4.5921 7.20658 5.44737 7.10474 6.31579 7.10526C7.18421 7.10526 8.03947 7.20737 8.88158 7.41158C9.72368 7.61579 10.5526 7.92158 11.3684 8.32895C11.75 8.52632 12.0561 8.81263 12.2866 9.18789C12.5171 9.56316 12.6321 9.97421 12.6316 10.4211V12.6316H0Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.508b8b2b477859de54e0e6872bf551a6.svg";
export { ForwardRef as ReactComponent };